import React from 'react';

export default function StyleGuide() {
  return (
    <div className="style-guide">
      <h1>Style Guide</h1>

      <div className="style-guide__section">
        <h2>Buttons</h2>
        <div className="style-guide__grid">
          <div className="style-guide__item">
            <button className="btn">Default Button</button>
            <pre><code>.btn</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--primary">Primary Button</button>
            <pre><code>.btn.btn--primary</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--secondary">Secondary Button</button>
            <pre><code>.btn.btn--secondary</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--ghost">Ghost Button</button>
            <pre><code>.btn.btn--ghost</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--success">Success Button</button>
            <pre><code>.btn.btn--success</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--danger">Danger Button</button>
            <pre><code>.btn.btn--danger</code></pre>
          </div>
          <div className="style-guide__item">
            <button className="btn btn--warning">Warning Button</button>
            <pre><code>.btn.btn--warning</code></pre>
          </div>
        </div>
      </div>

      <div className="style-guide__section">
        <h2>Cards</h2>
        <div className="style-guide__grid">
          <div className="style-guide__item">
            <div className="card-base" style={{padding: '1rem'}}>
              <p>This is a base card.</p>
            </div>
            <pre><code>.card-base</code></pre>
          </div>
        </div>
      </div>

      <div className="style-guide__section">
        <h2>Inputs</h2>
        <div className="style-guide__grid">
          <div className="style-guide__item">
            <input type="text" className="input" placeholder="Text Input" />
            <pre><code>.input</code></pre>
          </div>
        </div>
      </div>

    </div>
  );
}
